import React from "react";
import { ServicesTemplate } from "../../../components/templates";

function Services() {
  return <ServicesTemplate />;
}

export default Services;
